<template>
    <div class="row">
        <div class="col-12">
            <card>
                <div class="card-body">
                    <div class="row" v-if="isAdmin">
                      <div class="col-12">
                        <div class="float-right mb-4">
                          <button class="btn btn-secondary btn-sm" @click="export2Excel">
                            <i class="fas fa-download fa-fw"></i> Download XLS
                          </button>
                        </div>
                      </div>
                    </div>
                    <v-server-table 
                      ref="vuetable"
                      url="/dtable/inventory" 
                      :columns="dyn_cols" 
                      :options="options"
                    >
                        <template slot="beforeFilter">
                            <h2>
                                <i class="fas fa-archive text-primary"></i> {{$t('inventory.title')}}
                            </h2>
                        </template>
                        <template slot="type_name" slot-scope="props">
                            <span
                                class="badge badge-warning text-white"
                                v-if="props.row.type_name == 'In Warranty'"
                            >{{ $t('part.button.' + props.row.type_name.toLowerCase().replace(/\s/g, '')) }}</span>
                            <span
                                class="badge badge-success text-white"
                                v-if="props.row.type_name == 'Early Kit'"
                            >{{ $t('part.button.' + props.row.type_name.toLowerCase().replace(/\s/g, '')) }}</span>
                            <span
                                class="badge badge-primary"
                                v-if="props.row.type_name == 'Stock'"
                            >{{ $t('part.button.' + props.row.type_name.toLowerCase().replace(/\s/g, '')) }}</span>
                            <span
                                class="badge badge-dark"
                                v-if="props.row.type_name == 'Canabalizacao'"
                            >{{ props.row.type_name }}</span>
                        </template>
                        <template slot="id" slot-scope="props" class="btn-group" role="group" v-if="isAdmin">
                            <router-link
                                class="btn btn-xs btn-primary mr-1"
                                :to="{ name: 'inventory_edit', params: { id: props.row.id } }"
                            >
                                <i class="fas fa-edit fa-fw"></i>
                            </router-link>
                        </template>
                    </v-server-table>
                </div>
            </card>
        </div>
    </div>
</template>
<script>
export default {
  computed: {
    dyn_cols() {
      return ["asf", "part", "sku", "quantity", "reserved", "type_name", "id"];
    },
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    }
  },
  data() {
    return {
      options: {
        dateColumns: [],
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          part: () => this.$t('inventory.name'),
          sku: () => this.$t('inventory.sku'),
          reserved: () => this.$t('inventory.reserved'),
          type_name: () => this.$t('inventory.stock'),
          quantity: () => this.$t('inventory.quantity'),          
          id: ""
        },
        texts: {
          count: this.$t('field.count'),
          filter: this.$t('field.filter'),
          filterPlaceholder: this.$t('field.filterplaceholder'),
          limit: this.$t('field.limit'),
        },
        columnsClasses: { id: "text-right" },
        skin: "table table-sm table-hover",
        pagination: {
          edge: true
        },
        params: {
          asf: this.$store.getters["auth/getCurrentAsf"]
        },
        sortIcon: {
          base: "fas fa-sort",
          up: "fas fa-sort-up",
          down: "fas fa-sort-down",
          is: "fas fa-sort"
        }
      }
    };
  },
  methods: {
    getCurrentDate(){
      var myDate = new Date();
      var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
      var day = ('0' + myDate.getDate()).slice(-2);
      var year = myDate.getFullYear();
      return year + '-' + month + '-' + day;
    },
    export2Excel() {
      import('@/excel/Export2Excel').then(excel => {
        
        const tHeader = this.dyn_cols.slice(0, -1);//['Serial number', 'Nickname?', 'Full name'];  // Set the title of the first row of Excel table
        const filterVal = this.dyn_cols.slice(0, -1);//['index', 'nickName', 'name'];  // index, nickName and name are properties of objects in tableData
        const list = this.$refs.vuetable.data;  //Save tableData in data to list
        const data = this.formatJson(filterVal, list);
        
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: this.$t('global.repairs') + '_' + this.getCurrentDate(), //Optional
          autoWidth: true, //Optional
          bookType: 'xlsx' //Optional
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  }
};
</script>
<style>
</style>
